import React, {FC} from 'react';

import {CopyLink} from './CopyLink';
import {useSharing} from './mutation.sharing';
import {Status} from './Status';

import * as styles from './styles.module.scss';

type SharingProps = {
	cache: string
	owner: boolean
}

export const Sharing: FC<SharingProps> = ({cache, owner}) => {
	const sharing = useSharing(cache);
	return (
		<div className={styles.sharing}>
			<div className={styles.widgets}>
				<Status sharing={sharing} owner={owner} />
				{owner && <CopyLink sharing={sharing} />}
			</div>
			<hr />
		</div>
	);
};
